import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { BaseUrl } from "../../Container/BaseUrl/BaseUrl";
import { IoIosArrowBack } from "react-icons/io";
import { DownloadSimple, FunnelSimple } from "@phosphor-icons/react";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";
import {
  ButtonGroup,
  Button,
  Pagination,
  Stack,
  Typography,
  Box,
  Drawer,
} from "@mui/material";
import moment from "moment";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import makeAnimated from "react-select/animated";
import {
  setSelectedMenu,
  getAvailableAgentList,
} from "../../Redux/Actions/actions";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import FilterListIcon from "@mui/icons-material/FilterList";
import { toaststyle } from "../../Utils/toaststyle";
import { TiWarningOutline } from "react-icons/ti";
import { Hourglass } from "react-loader-spinner";
import {
  StyledPaper,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableBody,
  StyledTableRow,
  StyledTableCell,
  StyledTableCell2,
  StyledTableCell3,
  StyledTableCell4,
} from "../../CustomComponent/TableCompoent";

const mapStateToProps = (state) => {
  return {
    selectedMenu: state.contactListData.selectedMenu,
    DropDownAgentList: state.contactListData.DropDownAgentList,
  };
};
const AgentStatusReport = (props) => {
  const selectAgentRef = useRef(null);
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];
  const [agentstatus, setagentstatus] = useState([]);
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [agentid, setAgentid] = useState("");
  const [pagination, setPagination] = useState(0);
  const [page, setPage] = useState(1);
  const [loadingAgentreports, setLoadingAgentreports] = useState(false);
  const [showfilter, setShowFilter] = useState(false);
  const [selectedagent, setSelectedagent] = useState("");

  const [fromDateError, setFromDateError] = useState(false);
  const [toDateError, setToDateError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const formatRingTime = (seconds) => {
    const duration = moment.duration(seconds, "seconds");
    const formatted = moment.utc(duration.asMilliseconds()).format("HH:mm:ss");
    return formatted;
  };

  const handleSubmit = () => {
    if (moment(fromdate).isAfter(todate)) {
      setFromDateError(true);
      setToDateError(false);
      setShowFilter(true);
    } else {
      agentReportData();
      setToDateError(false);
      setFromDateError(false);
      handelCloseFilter();
    }
  };
  const handelShowFilter = () => {
    setShowFilter(true);
  };
  const handelCloseFilter = () => {
    setShowFilter(false);
  };

  useEffect(() => {
    props.getAvailableAgentList();
    agentReportData();
  }, [page]);

  const agentReportData = async () => {
    setLoading(true);
    const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        BaseUrl + "/users/agentstatusreport",
        {
          from_date: fromdate !== "" ? fromdate : "",
          to_date: todate !== "" ? todate : "",
          offset: page == 1 ? 0 : (page - 1) * 10,
          limit: 10,
          agent_id: selectedagent ? selectedagent : "",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setLoading(true);
        if (res.data.success) {
          setLoading(false);
          setagentstatus(res.data.Data);
          setPagination(res.data.count);
          setLoadingAgentreports(false);
        } else {
          setLoading(false);
          setagentstatus([]);
          setLoadingAgentreports(false);
          setPagination(0);
        }
      })
      .catch((error) => {
        setLoading(false);
        setagentstatus([]);
        setLoadingAgentreports(false);
        setPagination(0);
      });
  };

  const agentReportData1 = async (ToPage1) => {
    setLoading(true);
    const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        BaseUrl + "/users/agentstatusreport",
        {
          from_date: fromdate !== "" ? fromdate : "",
          to_date: todate !== "" ? todate : "",
          offset: ToPage1,
          limit: 10,
          agent_id: selectedagent ? selectedagent : "",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setLoading(true);
        if (res.data.success) {
          setLoading(false);
          setagentstatus(res.data.Data);
          setPagination(res.data.count);
          setLoadingAgentreports(false);
        } else {
          setLoading(false);
          setagentstatus([]);
          setLoadingAgentreports(false);
          setPagination(0);
        }
      })
      .catch((error) => {
        setLoading(false);
        setagentstatus([]);
        setLoadingAgentreports(false);
        setPagination(0);
      });
  };

  const DownloadAgentStatusReports = async () => {
    setIsLoading(true);
    const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        BaseUrl + "/users/agentstatusreportexcel",
        {
          from_date: fromdate !== "" ? fromdate : "",
          to_date: todate !== "" ? todate : "",
          offset: page == 1 ? 0 : (page - 1) * 10,
          limit: 10,
          agent_id: selectedagent ? selectedagent : "",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setIsLoading(true);
        if (res.data.status == true) {
          setIsLoading(false);
          let downloadUrl = "https://dcc.ntt.inaipi.ae/files";
          let file =
            localStorage.getItem("frontendBaseURL") +
            "files" +
            res.data.message;
          window.open(file);
          toast.success(
            "Agent Status Report Downloaded Successfully",
            toaststyle
          );
        } else {
          toast.warn("No Data Found", toaststyle);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        toast.warning("No Data Found", toaststyle);
      });
  };
  const handleChange = (event, value) => {
    setPage(value);
  };
  const resetButton = () => {
    setTodate("");
    setFromdate("");
    setSelectedagent("");
  };

  return (
    // Agent Status Report start
    <StyledPaper>
      <div className="card Report-card w-100 border-0">
        {/* card-header  */}
        <div
          className="card-header border-0 d-flex align-items-center justify-content-between px-2"
          sx={{ fontWeight: 600, color: "#1473e6" }}
        >
          <div
            className="fw-bold fs-16"
            style={{
              textShadow: "1px 0px 0px #c2c2c27d",
              color: "#0b3363",
            }}
          >
            Agent Status Report
          </div>
          <div>
            <ButtonGroup
              variant="contained"
              aria-label="button group"
              disableElevation
              size="small"
              sx={{
                textTransform: "capitalize",
              }}
            >
              {/* Back btn  */}

              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  props.setSelectedMenu("ReportMenu");
                }}
              >
                <IoIosArrowBack className="me-2" />
                Back
              </Button>

              {/* Download btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={DownloadAgentStatusReports}
                disabled={isLoading}
              >
                <DownloadSimple className="me-2" />
                {isLoading ? "Downloading..." : "Download Report"}
              </Button>
              {/* Filter btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={handelShowFilter}
              >
                <FunnelSimple className="me-2" />
                Filter
              </Button>
            </ButtonGroup>
          </div>
        </div>
        {/* card-body */}
        <div
          className="card-body p-1 vh-71 box-inset"
          sx={{
            justifyContent: "center",
            display: "flex",
            height: "calc(100% - 40px)",
            display: "flex",
            flexDirection: "column",
            gap: "10",
          }}
        >
          <Box>
            <StyledTableContainer sx={{ height: "26rem !important" }}>
              <StyledTable stickyHeader aria-label="sticky table" size="small">
                <StyledTableHead>
                  <StyledTableRow>
                    {["Agent Name", "Agent Status Report"].map((headers) => (
                      <StyledTableCell style={{ minWidth: "150px" }}>
                        {headers}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                </StyledTableHead>
                <StyledTableBody>
                  {loading ? (
                    <Stack
                      sx={{ position: "absolute", top: "50%", left: "50%" }}
                    >
                      <Hourglass
                        visible={true}
                        height="30"
                        width="30"
                        ariaLabel="hourglass-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        colors={["#2268a0", "#72a1ed"]}
                      />
                    </Stack>
                  ) : agentstatus.length > 0 ? (
                    agentstatus.map((rowData) => {
                      return (
                        <StyledTableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={rowData._id}
                        >
                          <StyledTableCell2>
                            {rowData.users.username}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            <StyledTable
                              stickyHeader
                              aria-label="sticky table"
                              size="small"
                            >
                              <StyledTableHead>
                                <StyledTableRow>
                                  {[
                                    "Date",
                                    "Agent Status",
                                    "Start Time",
                                    "End Time",
                                    "Duration",
                                    "Total Duration",
                                  ].map((headers) => (
                                    <StyledTableCell4
                                      style={{ minWidth: "150px" }}
                                    >
                                      {headers}
                                    </StyledTableCell4>
                                  ))}
                                </StyledTableRow>
                              </StyledTableHead>
                              <StyledTableBody>
                                {rowData.documents.map((item, index) => {
                                  const seconds = item.duration;
                                  const duration = moment.duration(
                                    seconds,
                                    "seconds"
                                  );
                                  const hours = Math.floor(duration.asHours());
                                  const minutes = duration.minutes();
                                  const secs = Math.floor(duration.seconds());
                                  const formattedTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
                                  return (
                                    <StyledTableRow
                                      hover
                                      role="checkbox"
                                      tabIndex={-1}
                                      key={index}
                                    >
                                      <StyledTableCell3>
                                        {moment(item.created_at).format("ll")}
                                      </StyledTableCell3>

                                      <StyledTableCell3>
                                        {item.value}
                                      </StyledTableCell3>

                                      <StyledTableCell3>
                                        {moment(item.created_at).format(
                                          "HH:mm:ss"
                                        )}
                                      </StyledTableCell3>

                                      <StyledTableCell3>
                                        {moment(item.ended_at).format(
                                          "HH:mm:ss"
                                        )}
                                      </StyledTableCell3>

                                      <StyledTableCell3>
                                        {formattedTime}
                                      </StyledTableCell3>
                                      {index === 0 && (
                                        <StyledTableCell3
                                          rowSpan={rowData.documents.length}
                                        >
                                          {formatRingTime(
                                            rowData.total_duration
                                          )}
                                        </StyledTableCell3>
                                      )}
                                    </StyledTableRow>
                                  );
                                })}
                              </StyledTableBody>
                            </StyledTable>
                          </StyledTableCell2>
                        </StyledTableRow>
                      );
                    })
                  ) : (
                    // Data unavailable start
                    <Stack
                      sx={{
                        position: "absolute",
                        width: "100%",
                        height: "calc(100vh - 14rem)",
                      }}
                      justifyContent="center"
                      alignContent="center"
                    >
                      <Stack
                        className="text-muted"
                        direction="column"
                        justifyContent="center"
                        alignContent="center"
                      >
                        <span className="mx-auto">
                          <img
                            src={Nodata}
                            alt="pic"
                            style={{ width: "11rem", userSelect: "none" }}
                          />
                        </span>
                        <span className="mx-auto">
                          <h6
                            className="text-muted mt-3"
                            style={{ fontSize: "13px" }}
                          >
                            Data unavailable
                          </h6>
                        </span>
                      </Stack>
                    </Stack>
                    // Data unavailable end
                  )}
                </StyledTableBody>
              </StyledTable>
            </StyledTableContainer>
          </Box>
        </div>
        {/* card-footer */}
        <div className="card-footer border-0">
          <Box>
            <Stack
              sx={{ width: "100%", height: "100%" }}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              {/* Pagination content  */}
              <Typography variant="caption" sx={{ fontSize: "12px" }}>
                Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                {Math.min(page * 10, pagination)} of {pagination} entries
              </Typography>
              {/* Pagination  */}
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}
                variant="outlined"
                shape="rounded"
                color="primary"
                size="small"
                style={{ float: "right" }}
                onChange={handleChange}
              />
            </Stack>
          </Box>
        </div>
      </div>

      {/* Filters Drawer Start  */}
      <Drawer
        anchor="right"
        open={showfilter}
        onClose={() => {
          setShowFilter(false);
        }}
      >
        <Box style={{ width: "20rem" }}>
          {/* Drawer head start */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="p-3 shadowDrawer"
          >
            <Typography variant="h3" gutterBottom className="drawer-title">
              Filters
            </Typography>
          </Stack>
          {/* Drawer head end */}
          {/* Drawer Content start */}
          <Stack
            className="p-3"
            style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
          >
            <form className="fs-13">
              <div className="custom_div">
                <div className="mb-3 d-flex flex-column text-start">
                  <label for="exampleInputfromdate" className="form-label">
                    From Date <small className="text-danger">*</small>
                  </label>
                  <input
                    type="date"
                    value={fromdate}
                    onChange={(e) => {
                      setFromdate(e.target.value);
                    }}
                    className="form-control form-control-lg"
                    id="exampleInputfromdate"
                  />
                  {fromDateError ? (
                    <span
                      className="text-danger fw-500"
                      style={{ fontSize: "10px" }}
                    >
                      From Date Should Less Than To Date
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label for="exampleInputtodate" className="form-label">
                    To Date <small className="text-danger">*</small>
                  </label>
                  <input
                    value={todate}
                    type="date"
                    onChange={(e) => {
                      setTodate(e.target.value);
                    }}
                    className="form-control form-control-lg"
                    id="exampleInputtodate"
                  />
                </div>

                <div className="mb-3">
                  <label for="exampleInputfromdate" className="form-label">
                    Agent <small className="text-danger">*</small>
                  </label>
                  <select
                    className="form-select"
                    onChange={(e) => setSelectedagent(e.target.value)}
                    value={selectedagent}
                  >
                    <option value="">All Agent</option>
                    {props.DropDownAgentList.length > 0 ? (
                      props.DropDownAgentList.map((item) => {
                        return (
                          <>
                            <option value={item.id}>{item.username}</option>
                          </>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </select>
                </div>
              </div>
            </form>
          </Stack>
          {/* Drawer Content end */}
          {/* Drawer footer start */}
          <Stack
            className="p-2"
            sx={{
              position: "absolute",
              bottom: "0",
              background: "#f9f9f9",
              width: "100%",
              boxShadow:
                "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
            }}
            direction="row"
            justifyContent="space-between"
            alignContent="center"
          >
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="error"
              disableElevation
              onClick={handelCloseFilter}
            >
              Close
            </Button>
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="warning"
              disableElevation
              onClick={resetButton}
            >
              Reset
            </Button>
            <Button
              className="w-100"
              variant="contained"
              disableElevation
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              id="session_filter_Submit"
              onClick={() => {
                if (moment(fromdate).isAfter(todate)) {
                  setFromDateError(true);
                } else {
                  setFromDateError(false);
                  agentReportData1(0);
                  setPage(1);
                  setShowFilter(false);
                }
              }}
            >
              Submit
            </Button>
          </Stack>
          {/* Drawer footer end */}
        </Box>
      </Drawer>
      {/* Filters Drawer End  */}
    </StyledPaper>
    // Agent Status Report end
  );
};

export default connect(mapStateToProps, {
  setSelectedMenu,
  getAvailableAgentList,
})(AgentStatusReport);
